export default {
  en: {
    loading: "Loading...",
    title: "Title",
    description: "Description",
    tags: "Tags",
    date: "Date",
    ui: {
      title: "Ground Truth",
      Family: "Family",
      "Al Turi": "Al Turi",
      Uqbi: "Uqbi",
      "Abu Freih": "Abu Freih",
      "Abu Siam": "Abu Siam",
      "Abu Al Tayf": "Abu Al Tayf",
      "Marker Group": "Sites",
      Plot: "Plot",
      Burial: "Burial",
      Cistern: "Cistern",
      Cultivated: "Cultivated",
      Fortifications: "Fortifications",
      Granary: "Granary",
      House: "House",
      "Land Feature": "Land",
      Tent: "Tent",
      "Un-cultivated": "Un-cultivated",
      Well: "Well",
      Image: "Photographs",
      Audio: "Audio",
      Video: "Video",
      Cemetery: "Cemetery"
    },
    cabinet: {
      terms: {
        overtitle: "الـحقيقة الأرضيّة",
        title: "Ground Truth",
        untertitle: "Destruction and Return in al-'Araqīb",
        untertitle_ar: "سِجلّات التهجير والعودة",
        explore: "Explore",
        about: "The project",
        methodology: "Method",
        history: "History",
        resources: "Documents",
        collaborators: "Partners",
        investigate: "Explore",
        land: "Land documents",
        map: "Maps and Aerial images"
      },
      about: [
        { type: "h2", text: "The project" },
        {
          type: "video",
          src:
            "https://player.vimeo.com/video/223268224?title=0&byline=0&portrait=0"
        },
        {
          text:
            "Ground Truth is an ongoing project that aims to provide historical and juridical evidence on behalf of communities in the illegalised Palestinian Bedouin villages in the northern threshold of the Negev/Naqab desert, Israel. While forced physical displacement and illegalisation render these communities non-existent on maps and aerial imaging, state-led land works and afforestation transform and erase their land and material cultural remains. The project aims to document and collate disparate legal, historical, and material evidence for the continuity of the sedentary presence of the Bedouin population on this land, as well as traces of their repeated displacement and destruction by government forces."
        },
        {
          text:
            "At the heart of the project are a community-led photographic dossier and a 3DGiS platform that utilises contemporary and historical images to map the presence and remnants of the Bedouin's inhabitation. This first iteration of the project centres on the case of the al-'Araqīb village, which has been demolished over 116 times over the past 60 years. A second phase of the project would wish to expand the work into more unrecognised villages where establishing proof of continuity of presence would be helpful."
        },
        {
          text:
            "Through a collaborative process of DIY aerial photography with Public Lab, Zochrot, and the local families of al-'Araqīb, a kind of 'civic satellite' is formed. We use kites and balloons equipped with simple cameras to form a methodology through which aerial and ground views can be gathered across multiple expeditions. These are assembled through photogrammetry into stacked geo-referenced 3D point-cloud photo terrains. Photographs, taken by residents and activists, document not only expulsion and destruction but also their ongoing life and resistance. These photographs, along with other media, data, and testimony, attest to an inflicted violence by connecting the history of this local land struggle to larger-scale and longer-term environmental transformations and to the conflicts that such changes have provoked."
        },
        { type: "h2", text: "Collaborating organizations" },
        {
          text:
            '<i>Ground Truth</i> is an ongoing collaboration between several organizations and the Bedouin community of al-\'Araqīb, which began in 2015 and culminated in a public event and conference: "<a href="http://zochrot.org/en/gallery/55860">Ground Truth: Testimonies of Dispossession, Destruction and Return in the Naqab/Negev</a>".'
        },
        {
          text:
            "<b>The community of al-'Araqīb</b>: Nūri al-Uqbi, Sheikh Sayah al-Tūri, Aziz al-Tūri , Sabach al-Tūri Marim abu Mad’im, Salim al-Tūri"
        },
        {
          text:
            '<b><a target="_blank" href="//www.forensic-architecture.org">Forensic Architecture</a></b> is a research agency based at Goldsmiths, University of London.  It includes a team of architects, scholars, filmmakers, designers, lawyers and scientists who undertake research that gathers and presents spatial analysis and evidence for international prosecution teams, political organisations, NGOs, and the United Nations. Additionally, the agency undertakes historical and theoretical examinations of the history and present status of forensic practices in articulating notions of public truth.'
        },
        {
          text:
            "Forensic Architecture team: Eyal Weizman (Principle Investigator), Ariel Caine (Project Coordinator & Researcher), Franc Camps-Febrer (Design & Software Development), Samaneh Moafi (Film editing),  Christina Varvia."
        },
        {
          text:
            '<b><a target="_blank" href="//www.zochrot.org">Zochrot</a></b> (<i>remembering</i> in Hebrew) is an NGO working in Israel since 2002 to promote acknowledgement and accountability for the Nakba, the Palestinian catastrophe of 1948 and the reconceptualization of the Return of the Palestinian Refugees as the imperative redress of the Nakba. Zochrot’s main projects include tours to the sites of destroyed Palestinian villages, seminars for educators, collection of oral testimonies, art gallery, an annual film festival and an online archive about the Nakba.'
        },
        { text: "Zochrot team: Debby Farber, Umar al-Ghubari" },
        { text: "And other associate organizations:" },
        {
          text:
            '<b><a target="_blank" href="//www.publiclab.org">Public Laboratory for Open Technology and Science (Public Lab)</a></b> is a community that applies low cost, easy-to-use open source hardware and software for investigating environmental health and justice issues. Its core program is focused on promoting grassroots "civic science" and locally-relevant outcomes that emphasize human capacity and understanding. Team: Hagit Keysar.'
        },
        {
          text:
            '<b><a target="_blank" href="//www.activestills.org">ActiveStills Collective</a></b> collective was established in 2005 by a group of documentary photographers out of a strong conviction that photography is a vehicle for social and political change. They believe in the power of images to shape public attitudes and raise awareness on issues that are generally absent from public discourse. ActiveStills view themselves as part of the struggle against all forms of oppression, racism, and violations of the basic right to freedom.'
        },
        {
          text:
            "The collective – comprised of Israeli, Palestinian and international photographers - operates in Palestine/Israel and focuses on social and political documentation, publications, and exhibitions. It works on various topics including: the Palestinian popular struggle against the Israeli occupation, rights of women, LGTBQ, migrants and asylum-seekers, public housing, and other forms of economic oppression. Team: Oren Ziv, Keren Manor, Yotam Ronen."
        },
        {
          text:
            "<b>Professor Oren Yiftachel</b> teaches political and legal geography, urban and regional planning and public policy at Ben-Gurion University of the Negev. Yiftachel is one of the main critical geographers and social scientists working in Israel/Palestine."
        },
        {
          text:
            '<b><a target="_blank" href="http://www.chelouchegallery.com/artistWorks.php?id=49">Miki Kratsman</a></b> Miki Kratsman an artist and photographer. "The Bedouin Visual Archive", a project which he is undertaking in collaboration with the Negev Coexistence Forum (NCF) is aiming to use narrative and visual literacy to raise awareness to the rights violations of the Bedouin and give voice to their silenced histories and claims on the land.'
        },
        {
          text:
            "As part of his work in the Negev and specifically in al-'Araqīb, Miki Kratsman took part in the discussions, meetings and conceptualisation around the formation of this project."
        },
        {
          text:
            "<b>Michael Sfard (Michael Sfard Law Office | Legal Partners)</b> is a lawyer specializing in international human rights law and the laws of war. He has served as counsel in various cases on these topics in Israel. Sfard has represented a variety of Israeli and Palestinian human rights and peace organizations, movements and activists at the Israeli Supreme Court. Team: Michael Sfard, Carmel Pomerantz."
        },
        {
          text:
            "<b>Forensic Architecture, Masters Course students (MAFA)</b> at Centre for Research Architecture Goldsmiths, University of London, 2017."
        },
        {
          text:
            '<b>Princeton University Conflict Shorelines II course students</b>,  taught by <a target="_blank" href="http://synesthesia.princeton.edu/participants/eduardo-cadava/">Eduardo Cadava</a> and <a target="_blank" href="http://synesthesia.princeton.edu/participants/eyal-weizman/">Eyal Weizman</a> in spring 2017.'
        }
      ],
      methodology: [
        {
          text:
            "In order to produce highly detailed aerial imagery and mapping on a continuous basis alongside and for the local bedouin families (al-Uqbi, al-Tūri) we use a method utilising tools that are as unobtrusive and transparent in their ways of operation as possible. Based on methods developed by Public Lab (PublicLab.org) we attach small, consumer level point and shoot cameras (canon, GoPro Hero5 black, Olympus TG-4) taking nadir images at 1fps-4fps (on continuous/time lapse mode) to single line kites and helium filled balloons. The camera is connected via a protective bottle encasing or a Public-Lab 3Dprinted mount, exposure is set and then the camera is sent up with the kite/balloon into the air. We then walk the area we wish to photograph from the air, pulling the kite/balloon with us. the camera lenses  are set to a relatively wide angle, equivalent to 20-35mm lens of Full-Frame film camera. Once a session ends we have a set of between several hundred to thousands of images documenting the entire length of the flight. the images are named and numbered consecutively in the camera and have a time and date stamp in their metadata. In current camera models we are using there is also basic GPS information embedded into each frame."
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/kite.jpg",
          caption:
            "Kite & Camera over the Cistern of Muhammad Ibn Salame Al-Uqbi, Nov 2016"
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pic013.jpg",
          caption:
            "Kite & Camera over al-Tūri Cemetery Jan 2016 Ariel Caine , Hagit Keysar  and children of al-Araqib."
        },
        {
          text:
            "In order to form the 3D terrains from the kite aerial photographs we used a computational process called photogrammetry. Photogrammetry is a process by which distance and movement measurement is extracted computationally from comparison of several still photographs. through a process of triangulation taking into consideration the lens information extracted from the image metadata, every photograph is positioned in 3D space and each pixel of the original images is also allocated its corresponding place in the 3D environment."
        },
        {
          text:
            "Each segment of the point-cloud model is georeferenced through ground control points (GCP) noting longitude latitude and height information. Georeferencing is achieved through a combination of on camera metadata, existing survey information from map provided by Prof. "
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pointcloud.jpg",
          caption:
            "Point-Cloud of the Well of Awimer Salman Abu Medigam, Sep 2016. The blue rectangles depict the positions of individual image frames from which the 3D information was derived."
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/photogrammetry.png",
          caption:
            "Point Cloud processing and geo referencing.  Ariel Caine & Forensic Architecture."
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pic003.jpg",
          caption:
            "A kite camera & plastic bottle rig. Hagit Keysar, Ariel Caine & Forensic Architecture, 2016."
        },
        {
          text:
            "Photogrammetry is a process by which distance and movement measurement is extracted computationally from comparison of several still photographs. through a process of triangulation taking into consideration the lens information extracted from the image metadata, every photograph is positioned in 3D space and each pixel of the original images is also allocated its corresponding place in the 3D environment."
        }
      ],
      history: [
        { type: "h2", text: "Background" },
        {
          text:
            'The Bedouin population residing in the Negev/Naqab Desert, the southern region of Israel/Palestine, is the most marginalized and impoverished group of the Arab-Palestinian citizens of Israel. Prior to the establishment of the State of Israel in 1948, or the Nakba ("catastrophe" in Arabic), some 92,000 Palestinian Bedouins lived in the Naqab desert in the southern region of historic Palestine. Both the Ottoman administration and the British Mandate that followed it recognized traditional forms of Bedouin land ownership. In the years immediately following the establishment of the state of Israel, the majority of the Bedouin community was forced to flee to neighboring states; The rest were scattered internally and concentrated in a limited area in the more arid parts of the Naqab desert.  Those 10% that remained were denied ownership and rights over their historic lands.'
        },
        {
          text:
            "Today, 160,000 Bedouins live in the Negev/Naqab, living in seven impoverished townships established by the Israeli state and in 46 villages, of which only 12 have been recognized by the state. Communities in these 'unrecognized villages' live off-the-map and off the grid, without services and infrastructures and in constant threat of dispossession. Throughout the past seven decades Israel has used the land from which it has evicted the Bedouins for exclusively Jewish settlement, polluting industries, waste dumps, prisons, military bases and training facilities."
        },
        {
          type: "img",
          src: "/assets/cabinet/history/Aziz_2008map_01.jpg",
          caption:
            "Aziz al-Tūri reading a 2009 aerial image of the al-Tūri cemetery and village before it’s demolition in 2010."
        },
        { type: "h2", text: "al-'Araqīb" },
        {
          text:
            "The demolitions in al-'Araqīb, like those of other illegalized Bedouin settlements, form the most recent chapter in what the Israeli establishment and the media now calls \"the battle over the Negev\": a systematic state campaign meant to uproot the Bedouins, concentrate them in purpose-built towns located mostly in the desert's more arid parts, and hand over their lands for the purpose of Jewish settlement."
        },
        {
          type: "highpoint",
          text:
            'The original inhabitants of al-\'Araqīb and their descendants have exercised their "right of return", physically, persistently on the ground, rebuilding after every cycle of demolitions.'
        },
        {
          text:
            "At its peak, the population of the village of al-'Araqīb was of about four hundred people, mostly from the extended al-Tūri family. Now only a small core of a dozen or so inhabitants remains, within the grounds of the old al-Tūri cemetery, right next to the graves. The current demolition count started only in the early 2000s, but the first expulsions had already begun in 1951, three years after the end of the 1948 war, when the Israeli military turned its attention to the Bedouins and started expelling them, as it did with other Palestinians. Since then, at irregular intervals that sometimes lasted months, other times decades, the original inhabitants of al-'Araqīb and their descendants have exercised their \"right of return\", physically, persistently, continuously rebuilding after every cycle of demolitions. Traces on the ground — wells, structures, ruins and, most importantly, the cemetery — keep the possibility of return alive. Although every return is followed by expulsions, the Bedouin Nakba continue."
        },
        {
          text:
            "Some of the acts of return were led by Nūri al-Uqbi, Sheikh Suleiman's son, who had since founded the Association for the Defense of Bedouin Rights, a small (often one-man) NGO, the first of its kind, committed to the Bedouin land struggle. The cycle of returns, demolitions and confrontations escalated in the early 2000s after the al-Tūris returned to build their village next to their ancestral cemetery. In these years, Nūri al-Uqbi set up a protest tent a kilometer or so west, next to the ruins of his father's house. By then, the area had been radically transformed. Al-'Araqīb was no longer part of the open frontier of the desert's edge, but had become a small landlocked \"island\" surrounded on all sides by Jewish agricultural settlements, forests, military bases, a highway, a railway and a major waste-disposal facility."
        },
        { type: "h2", text: "Ground Truth Commission" },
        { type: "img", src: "/assets/cabinet/history/groundtruth02.jpg" },
        {
          text:
            'In January 2016, together with the al-\'Araqīb Popular Committee, other Bedouin organizations and the anticolonial organization Zochrot, Forensic Architecture took part in building and assembling an alternative civil forum entitled Ground Truth, curated by Debby Farber with Aziz al-Tūri and Nūri al-Uqbi. It was an improvised institution in a temporary structure we built outside the al-Tūri cemetery. It involved testimonies and the collection of documents, and it also included the closing session of the Truth Commission on Nakba in the Naqab, a long-term project by Zochrot. <a href="http://zochrot.org/en/gallery/55860">"Ground Truth: Testimonies of Dispossession, Destruction and Return in the Naqab/Negev"</a>.'
        },
        {
          text:
            'The term "truth commission" might be misleading. Those truth commissions instituted in South America or in South Africa were instruments of "transitional justice", conceived to help societies engage the wounds of periods of state terror and move on. A truth commission undertaken in situations of ongoing conflict and colonization, however, is a tactical, political act which forms part of the struggle itself.'
        },
        {
          text:
            "Ground Truth was a forum for the gathering and presentation of testimony and evidence that was denied in court for reasons and under pretexts that we will see later. It thus also had to engage with the very conditions by which historical and legal evidence can be gathered, presented, seen, and heard. In addition, it examined the environment and the climate as subjects of history and law. This in itself required a radical shift between scales and several acts of translation: the nature of testimony and evidence of environmental violence is different from those pertaining to incidents of fast, eruptive violence. The temporality of the climate is long, and its physical extent could be vast. Environmental violence is slow and is produced by multiple lines of causality, both proximate and remote. Furthermore, such environmen- tal transformations and land conflicts are entangled with human-induced climate change."
        },
        {
          type: "video",
          src:
            "https://player.vimeo.com/video/223287790?title=0&byline=0&portrait=0"
        },
        {
          type: "img",
          src: "/assets/cabinet/history/pic058.jpg",
          caption:
            "Land documents presented at the Ground Truth Commission, 2016."
        },
        { type: "img", src: "/assets/cabinet/history/pic056.jpg" },
        {
          text:
            '<a target="_blank" href="https://www.youtube.com/watch?v=-ukCuvF7__E">Ground truth (Panel 1 - Part 1)</a>'
        },
        {
          text:
            '<a target="_blank" href="https://www.youtube.com/watch?v=S_9R8CbjfRw">Ground truth (Panel 1 - part 2)</a>'
        },
        {
          text:
            '<a target="_blank" href="https://www.youtube.com/watch?v=ZY5hmPxsyQI">Launch of the report of the Truth Commission for the events of 1948-1960 in the south</a>'
        },
        {
          text:
            "Ground Truth was scheduled for January 1 and 2, 2016, because we hoped the new year would give us a little breathing space, a stay on the forum’s inevitable demolition. On January 3, the structure was dismantled by its users, shortly before the bulldozers arrived to demolish it. The salvaged raw material has been used for the construction of several other structures in the area of the desert threshold."
        }
      ],
      resources: [
        {
          text:
            "The Ground Truth Commission on 1–2 January 2016 involved the collection of documents that testify for traditional Bedouin land tenure in the Naqab/Negev. They include land transfer documents, agreement on the extent of tribal areas between different tribe leaders, tilth tax receipts (for cultivation) paid to British and Israeli authorities, maps, voter registration forms, identification cards with place of birth and residence marked. These documents testify not only to the continuous inhabitation of these areas but also to the possibility of cultivating cereals at the threshold of the desert."
        },
        {
          text:
            "This collection is a first iteration of a forthcoming online archive of documentry evidence to land use."
        }
      ]
    }
  },

  ar: {
    loading: "...تحميل",
    title: `عنوان`,
    description: `وصف`,
    tags: `علامات`,
    date: `الزمن`,
    ui: {
      title: "الحقيقة الأرضية",
      Family: "الأسر",
      "Al Turi": "الطوري",
      Uqbi: "العقبي",
      "Abu Freih": "أبو فريح",
      "Abu Siam": "ابو صيام",
      "Abu Al Tayf": "ابو الطيف",
      "Marker Group": "مواقع",
      Plot: "قطعة",
      Burial: "دفن",
      Cistern: "صهريج",
      Cultivated: "مزروع",
      Fortifications: "التحصينات",
      Granary: "صومعة",
      House: "منزل",
      "Land Feature": " أرض",
      Tent: "خيمة",
      "Un-cultivated": "غير مزروع",
      Well: "بئر",
      Image: " تصوير",
      Audio: "صوت",
      Video: "فيديو",
      Cemetery: "مقبرة"
    },
    cabinet: {
      terms: {
        overtitle: "Ground Truth",
        title: "الحقيقة الأرضية ",
        untertitle: "التدمير والعودة الى العراقيب ",
        untertitle_ar: "Destruction and return in al-'Araqīb",
        explore: "بحث",
        about: "حول المشروع",
        methodology: "منهجية العمل",
        history: "خلفية تاريخية",
        resources: "وثائق",
        collaborators: "Partners",
        investigate: "بحث",
        land: "سجلات الأراضي",
        map: "خرائط و صور جويه"
      },
      about: [
        { type: "h2", text: "The project" },
        {
          type: "video",
          src:
            "https://player.vimeo.com/video/223268224?title=0&byline=0&portrait=0"
        },
        {
          text: `
              الحقيقة الأرضية هو مشروع جاري يهدف إلى توفير أدلة تاريخية نيابة عن سكان القرى البدوية الفلسطينية الواقعة على الحواف الشمالية لصحراء النقب، إسرائيل.
بالإضافة إلى التهجير القسري ورفض الاعتراف الرسمي اللذين يغيّبان هذه القرى عن الخرائط والصور الجوية، فإنّ المشاريع وعمليات التحريج التي تجرى في تلك المنطقة تحت إشراف الدولة تغيّر وتمحو معالم الأرض وما تبقى من الآثار الثقافية.
              `
        },
        {
          text: `
             يهدف المشروع إلى التوثيق والمقارنة بين الأدلة القانونية، التاريخية والمادية لاستمرارية المجتمعات البدوية الثابتة في المكان، وآثار تهجيرهم المتكرر وهدم مساكنهم من قبل السلطات الإسرائيلية
  `
        },
        {
          text:
            "يرتكز المشروع على حافظة صور فوتوغرافية التقطها السكان، ومنصة نظم معلومات جغرافية ثلاثية الأبعاد التي تستخدم صورًا حديثة وتاريخية لتحديد مكان الآثار التي تدل على الحياة البدو الفلسطينيين في المكان. المرحلة الأولى من المشروع تتمحور حول قرية العراقيب، التي هدمت اكثر من 130 مره على مدار 70 سنة، فاصبحت القرية رمز نضال القرى غير المعترف بها بالنقب. المرحلة الثانية من المشروع تهدف إلى توسيع نطاقه والوصول إلى المزيد من القرى غير المعترف بها، حيث أنّ ِإيجاد المزيد من الأدلة على استمرارية الحياة البدوية في المنطقة سيكون مجديًا جدًا للنضال نحو الاعتراف بملكيتهم للارض."
        },
        {
          text: `
  من خلال مسار التقاط صور جوية ذاتية بمشاركة فورنسيك اركيتكتشور( Forensic Architecture)،بابليك لاب (Public Lab)، جمعية ذاكرات والعائلات في قرية العراقيب، تم تطوير "قمر صناعي مدني" عن طريقه تم إنتاج صور جوية بمنظومة فردية DIY (افعلها بنفسك) . "القمر الصناعي المدني" مكون من طائرات ورقية أو بالونات  مزوّدة بكاميرات بسيطة لتطوير تقنية التقاط  المشاهد.
من خلال استعمال تقنية شبكية يتم تركيب الصور واضافة بيانات عن المحيط لاستخلاص مشهد جوي. .  تُجمَع هذه المشاهد بواسطة التصوير المساحي فيما يسمّى بـ  stacked geo-referenced 3D point-cloud photo terrains  مما يؤدي إلى ربط سطح الأرض في القرية مع ما يقع تحتها.`
        },
        {
          text: `
              المعالجة بتقنية ثلاثية الأبعاد للصور الملتَقطة بعدسة السكان والنشطاء لا تقتصر على توثيق التهجير والهدم، بل تشكّل أيضًا دلالة على الحياة المستمرة وعلى المقاومة. هذه الصور والوسائل الأخرى مثل المعطيات والشهادات، توثّق العنف المنهجي من خلال الربط بين النضال المحلي من أجل الأرض، والتحولات البيئية طويلة الأمد، والصراعات الناتجة عن هذه التغييرات. المشروع عبارة عن أرشيف ناشط وفعّال  لقرية العراقيب لذلك ندعو كل شخص  لديه مواد قد تكون ذات صلة بالمشروع للاتصال بنا على عنوان البريد الإلكتروني:  naqabplatform@gmail.com
              `
        },
        { type: "h2-right", text: "المنظّمات المشاركة" },
        {
          text: `
  "
  مشروع الحقيقة الأرضية هو ثمرة تعاون مستمر بين وكالة بحثية Forensic Architecture، جمعية ذاكرات، Public Lab  والمجتمع  البدوي في العراقيب، والذي بدأ عام 2015 وتُوّجَ بحدث جماهيري ومؤتمر بعنوان: "الحقيقة الأرضية: الشهادات والحِرمان، الهدم والعودة في النقب".
              `
        },
        {
          text: `
              سكان العراقيب المشاركون: نوري العقبي، الشيخ صياح ابو مديغم الطوري، عزيز الطوري، سليم ابو مديغم، احمد ابو مديغم، عواد ابو فريخ، صباح الطوري، حكمة الطوري، مريم أبو مديغم.
              `
        },
        {
          text: `
              Forensic Architecture هي وكالة بحثية في مجال المعماري القضائي تنشط في  جامعة غولدسميث، لندن. تضم فريقًا من المهندسين المعماريين، الباحثين، المُخرجين، المصمّمين، المحامين والعلماء، المخولين بإجراء أبحاث  لجمع وتقديم أدلة وتحليلات مكانية لطواقم قضائية،ـ منظمات سياسية، منظّمات غير حكومية وللأمم المتحدة. تجري الوكالة أيضًا دراسات تاريخية ونظرية للتاريخ وللواقع الحالي للممارسات القانونية من خلال توضيح مفاهيم الحقيقة العامة.
   فريق Forensic Architecture
  إيال وايزمان (مؤسس المعهد والباحث الرئيسي)، أريئيل كين (مركّز المشروع وباحث)، فرانك كامبس-فيبرير (مصمم ومطور برمجيات)، سمانه معافي (مونتاج أفلام) وكريستينا ﭬارﭬيا.
  `
        },
        {
          text: `
              "ذاكرات" هي منظّمة غير حكومية تنشط في إسرائيل منذ عام 2002 لتعزيز الاعتراف وتحمّل المسؤولية حيال النكبة الفلسطينية، وإعادة بلورة المفاهيم المرتبطة بحق العودة للاجئين  الفلسطينيين كتعويض صادق وحتمي عن النكبة. المشاريع الرئيسية لجمعية ذاكرات تشمل تنظيم جولات إلى قرى فلسطينية مدمّرة، حلقات دراسية للمربّين، جمع شهادات شفوية، تنظيم معارض فنية، مهرجان سينمائي سنوي وأرشيف إلكتروني عن النكبة والعودة.
يركز المشروع في جمعية ذاكرات:
ديبي فربر (مركزة معمل الفنون المرئية)، عمر الغباري (مركز الجولات ومشروع العودة).
مساعدات البحث: رنا غنايم، لوتا بيرج-تومسون
              `
        },
        {
          text: `
  (Public Lab)
              المختبر الجماهيري للتكنولوجيا والعلوم هو عبارة عن مجموعة من المنظّمات المشاركة الأخرى: تكنولوجيين، باحثون، ناشطون ، فنانون وخبراء ممن يعملون في استخدام وتطوير الأجهزة والبرمجيات للبحث البيئي، الثقافي والسياسي الهادف الى تمكين إنشاء، تحليل وتوزيع الصور الجوية بشكل فردي ومستقل. تعتمد الخرائط على تقنيات العتاد مفتوح المصدر (Open Hardware) وتقنيات افعلها بنفسك (Do It Yourself) التي تحتوي على مواد بسيطة مثل الطائرات الورقية، البالونات، الرباطات المطاطية أو القناني البلاستيكية.  هدفها الرئيسي يتمحور حول تعزيز "العلوم المدنية" الجماهيرية والنتائج المرتبطة بالسياق المحلي التي تركز على المهارات البشرية لتطوير القدرة على التصوير الجوي، تحليله واستخدامه .
  فريق العمل: حاغيت كيسار
              `
        },
        {
          text: `
              ActiveStills Collective: تأسست عام 2005 على يد مجموعة مصورين المؤمنين بأنّ التصوير الفوتوغرافي هو وسيلة للتغيير السياسي والمجتمعي. تؤمن هذه المجموعة بمقدرة الصور على بلورة مواقف عامة، كجزء من النضال ضد جميع أشكال القمع، العنصرية، وانتهاكات الحق الأساسي في الحرية وحقوق الانسان."
              `
        },
        {
          text: `
              The Collective- مجموعة مصورين إسرائيليين، فلسطينيين وأجانب، تنشط في فلسطين/إسرائيل، وتُعنى بالتوثيق الاجتماعي والسياسي، المنشورات والمعارض. تتطرق إلى عدة مواضيع، من بينها النضال الشعبي الفلسطيني ضد الاحتلال الإسرائيلي، حقوق النساء، مثليي الجنس، مزدوجي الاتجاه الجنسي والمتحولين جنسيًا، المهاجرين وطالبي اللجوء، الإسكان الحكومي والأشكال الأخرى من القمع الاقتصادي.فريق العمل المشارك بالمشروع: أورين زيـﭪ، كيرين مانور، يوتام رونين."
              `
        },
        {
          text: `
              بروفسور أورن يفتاحئيل، أستاذ الجغرافيا السياسية والقانونية، والتخطيط الحضري/مدني والإقليمي والسياسة العامة في جامعة بن غوريون في النقب. يفتاحئيل هو ناشط اجتماعي وسياسي لسنوات عديدة في مجال ترويج حقوق الإنسان في الأراضي المحتلة، وفي النضال من أجل العدالة التوزيعية والحقوق الاجتماعية والاقتصادية ، وفي النضال من أجل حق البدو في الاعتراف بحقوقهم على أراضيهم التاريخية. خدم كمستشار لمجلس القرى غير المعترف بها وقاد الفريق المهني الذي فحص تاريخ النزاع على الأرض بين أجزاء من قبيلة العقبي والدولة ، وأعد وقدم رأيًا خبيرًا حول القضايا تلك.
              `
        },
        {
          text: `
              ميكي كراتسمان- فنان ومصور. مشروع "الأرشيف البصري البدوي" الذي يديره بالتعاون مع منتدى التعايش السلمي في النقب (NCF) يهدف إلى استخدام السرد والثقافة البصرية لتعزيز الوعي حول انتهاك حقوق البدو، وإسماع أصواتهم المخرسة والمطالبة بحقهم في الأراضي."
              `
        },
        {
          text: `
              ميخائيل سفارد هو محامي متخصص في القانون الدولي لحقوق الإنسان وقوانين الحرب. عمل مستشارًا في هذا المجال في إسرائيل. مثّل سفارد العديد من المنظمات، الحركات والنشطاء الإسرائيليين والفلسطينيين المتداخلين في مجال السلام وحقوق الإنسان، أمام المحكمة العليا. فريق العمل: ميخائيل سفارد، كرمل بوميرانتز."
              `
        },
        {
          text: `
              Forensic Architecture، طلاب مساق في دراسات اللقب الثاني، في مركز الأبحاث المعمارية، غولدسميث، جامعة لندن، 2017.
              `
        },
        {
          text: `
              طلاب مساق Conflict Shorelines II في جامعة برنستون، الذي درّسه كلّ من إدواردو كاداﭬا وأيال وايزمان في ربيع 2017.
              `
        }
      ],
      methodology: [
        {
          text: ` من أجل إنتاج صور جوية وخرائط عالية الجودة استخدمنا تقنية التصوير الجوي التي طورها المختبر العام (Public Lab). بمساعدة عائلات قرية العراقيب قمنا بإنشاء صور جوية وخرائط باستخدام تقنيات افعلها بنفسك (Do It Yourself) مكّنت من التعامل مع قضايا اقليمية وبيئية التي لم تتناولها السلطات.`
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/kite.jpg",
          caption: `
كاميرا وطائرة فوق خرابة محمد ابن سلامة العقبي (نوفمبر- تشرين الثاني ٢٠١٦)
`
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pic013.jpg",
          caption:
            "Kite & Camera over al-Tūri Cemetery Jan 2016 Ariel Caine , Hagit Keysar  and children of al-Araqib."
        },
        {
          text: `
استخدمنا كاميرات رقمية صغيرة وسهلة (Canon, GoPro Hero5 Black, Olympus TG-4) المخصصة للتصوير من اعلى بمعدل 4-1 لقطة في الثانية (مع امكانية التصوير المتواصل). قمنا بتوصيل الكاميرات إلى طائرات ورقية بسيطة وبالونات هيليوم من خلال ربطها بإناء أو بزجاجة بلاستيكية واقية مقسومة الى نصفين. الجهاز عادة ما يكون مقوى بمساعدة خيطان وربطات بلاستيكية مما يؤدي الى الضغط المتواصل على زر التشغيل في الكاميرا بهدف استمرار التقاط الصور بشكل متواصل. يتم تحديد التعرض مسبقا ومن ثم يتم نقل الكاميرا إلى السماء على أجنحة طائرة ورقية أو بالون. تستهدف عدسة الكاميرا زاوية واسعة نسبيًا ، تقابل عدسة 25-35 مم لكاميرا أفلام كاملة الإطار.
              `
        },
        {
          text: `
بمجرد الانتهاء من جولة التصوير الفوتوغرافي، لدينا مجموعة من مئات أو آلاف الصور التي توثق رحلة كاملة. تتلقى الصور اسمًا وترقيمًا في الكاميرا بما في ذلك يتم توثيق رقمي للوقت والتاريخ. في طرازات الكاميرا التي نستخدمها اليوم، تحتوي كل لقطة على بيانات نظام تموضع عالمي ( GPS). يتم تطوير الصور الجوية عن طريق برنامج المصدر المفتوح (Open Source Initiative) الذي تم تطويره بواسطة المختبر العام mapknitter.org والذي يسمح بربط وتركيب الصور مع بعضها البعض لتغطية منطقة جغرافية كبيرة.

              `
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pointcloud.jpg",
          caption: `
بوينت كلاود لبئر عويمر سلمان ابو مديغم (سبتمبر- أيلول ٢٠١٦). المستطيلات الزرقاء تمثل أماكن الصور الفردية التي تم منها استخلاص المعلومات ثلاثية الأبعاد.
`
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/photogrammetry.png",
          caption: `
بئر أبو سيام - عملية المعلاجة والمرجعية الجغرافية بمساعدة برنامج بوينت كلاود. أريئل كيين و فورنسيك اركتكشير
`
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pic003.jpg",
          caption: `
كاميرا ملصقة على طائرة ورقية وزجاجة بلاستيكية. حاجيت كيسار، اريئل كيين وفورنسك اركتكشير (٢٠١٦)
`
        },
        {
          text: `
              من أجل توثيق باقي عائلات قرية العراقيب قبل هدم بيوتها من قبل قوات الكيرن كييمت أو قوات الشرطة، استخدمنا كاميرات رقمية عالية الجودة من أجل إنشاء نماذج ثلاثية الأبعاد دقيقة وعالية الجودة قدر الإمكان من المواقع المختلفة.
              `
        },
        {
          text: `
من أجل توثيق باقي عائلات قرية العراقيب قبل هدم بيوتها من قبل قوات الكيرن كييمت أو قوات الشرطة، استخدمنا كاميرات رقمية عالية الجودة من أجل إنشاء نماذج ثلاثية الأبعاد دقيقة وعالية الجودة قدر الإمكان من المواقع المختلفة.
`
        },
        {
          text: `
لهذا السبب استخدمنا عمليات رياضية خاصة بآلة المسح التصويري (Photogrammetry). في هذه العملية، يتم استخلاص قياسات المسافة والحركة من مقارنة بين العديد من الصور الثابتة. من خلال حساب عملية التثليث الذي يراعي بيانات العدسات من الوثائق الرقمية لكل صورة ويتم وضعها في مساحة ثلاثية الأبعاد، لذاك يأخذ كل بكسل في الصورة الأصلية مكانه الصحيح في البيئة ثلاثية الأبعاد. كل مقطع في مجموعة النقط التي يتم إنشاؤها بهذه الطريقة هو تقاطع مع نقاط التحكم الأرضية إذ يتلقى بيانات الطول والعرض والارتفاع. يتم الحصول على البيانات المستعرضة من خلال مجموعة من البيانات الرقمية على الكاميرا وبيانات المسح الأرضي المحدثة من خريطة قدمها لنا البروفيسور أورن يفتاحئيل، من جامعة بن غوريون في النقب. هذا يخلق نماذج قابلة للقياس وتحديد المواقع.
              `
        }
      ],
      history: [
        { type: "h2", text: "خلفية تاريخية" },
        {
          text: `
              السكان البدو المقيمون في صحراء النقب/نيجيف، في المنطقة الجنوبية من إسرائيل/فلسطين، هم الشريحة الأكثر تهميشًا بين مواطني الدولة العرب-الفلسطينيين. قبل أن غزا الصهيونيون فلسطين في عام 1948، سَكَن صحراء النقب، جنوبي فلسطين التاريخية، ما بين ال 65000 -100000 فلسطيني- بدوي وسيطروا على ما يقارب 5 مليون دونم. الحكومة العثمانية والانتداب البريطاني الذي حكم حتى عام 1994 اعترفوا بالأشكال التقليدية لملكية الأراضي المتبعة لدى البدو. "
              `
        },
        {
          text: `
              مصير البدو كان مشابها لمصير حوالي 800،000 فلسطيني تم طردهم من أراضيهم خلال النكبة والذين كانت عودتهم ممنوعة، حيث تم طردهم معظم سكان النقب إلى غزة، الضفة الغربية، الضفة الشرقية والأردن. رافقت عمليات التهجير هذه اعمال قتل وحشية، حرق خيام، وتدمير منازل حجرية وإغلاق الآبار. أجبر معظم البدو على الفرار إلى الدول المجاورة، ومن تبقى منهم عانوا التهجير الداخلي وحُصروا في منطقة مركّزة ومحدودة في الجزء الأكثر جفافًا في صحراء النقب المدعوة بالسياج. ما يقارب ال 11000 من البدو الذين بقيوا في البلاد بعد النكبة، حُرموا من حق الملكية على أراضيهم التاريخية. يعود ذلك إلى مجموعة من القوانين التي سنتها دولة إسرائيل منذ عام 1948، والتي تمكن من مصادرة الأراضي في النقب بسهولة، مع تبني منطق قانوني استعماري، والذي لقبه الجغرافي أورن يفتاحئيل ب "النقب الميت". تنص هذه العقيدة الوحشية على أن الأراضي التي يطالب بها البدو هي "موات" (اي اراضي ميتة) وأراضي مهجورة، وأنه حتى عهد الانتداب البريطاني لم تكن هناك مستوطنات بدوية كبيرة أو زراعة في النقب. بالاضافة الى اظهار البدو كالمتنقلين فاقدين الجذور، هذه العقيدة تستنزف حقوق الملكية التقليدية وتمكن الدولة من الحصول على الأراضي وتصفيتها. يتم ذلك عن طريق تجاهل البيانات والدلائل والآراء والحجج القانونية، الجغرافية والتاريخية التي تشير إلى الماضي الأصلي للنقب.
              `
        },
        {
          text: `
              يسكن حاليًا في النقب 230,000 بدوي، النصف تقريبا موزّعين على سبع مدن فقيرة أقامتها الدولة، و 50 قرية، من بينها 10 قرى تحظى باعتراف الدولة. المجتمعات في هذه "القرى غير المعترف بها" مغيّبة عن الخرائط، تفتقر للخدمات والبنى التحتية، إلى جانب كونها مهددة بفقدان ملكيتها على الأراضي. على مدار العقود السبعة الأخيرة، استخدمت دولة إسرائيل الأراضي التي انتزعت من البدو لغرض إقامة مستوطنات يهودية، صناعات ملوّثة، مكبات نفايات، سجون، قواعد عسكرية ومنشآت للتدريب."
              `
        },
        {
          type: "img",
          src: "/assets/cabinet/history/Aziz_2008map_01.jpg",
          caption:
            "Aziz al-Tūri reading a 2009 aerial image of the al-Tūri cemetery and village before it’s demolition in 2010."
        },
        { type: "h2", text: "العراقيب" },
        {
          text: `
              تعني كلمة "العراقيب" بالعربية التلال التي تمتد بين الجداول. الكلمة لها معاني أخرى ، لكن هذا المعنى يبدو أكثر ملاءمة للمنطقة والتي تمتلئ بالجداول والتلال اللطيفة. منطقة العراقيب كبيرة تمتد على حوالي 100,000 دونم. تعود ملكية هذه الأراضي إلى عدد من القبائل الفلسطينية والعائلات التي عاشت على أراضيها وعملت فيها لمئات السنين.
              `
        },
        {
          text: `
              الهدم المتكرر لقرية العراقيب، وغيرها من القرى البدوية غير المعترف بها، هي المرحلة التي نشهدها مؤخّرًا ضمن المسار المسمّى من قبل الإعلام والمؤسسة الإسرائيلية بـ "المعركة على النقب": وهي حملة منهجية أطلقتها الدولة لتشريد البدو، تركيزهم في بلدات مبنية خصيصًا لهم، في المناطق الأكثر جفافًا في صحراء النقب، وتخصيص هذه الأراضي للاستيطان اليهودي.
              `
        },
        {
          text: `
بلغ عدد سكان قرية العراقيب، في أفضل حالاتها، حوالي 400 نسمة. أما الآن، لم يتبق إلا عشرات السكان المتواجدين قريبا من أراضي مقبرة الطوري القديمة. الهدم المتكرر للقرية بدأ في مطلع العام 2010 (أصبح هناك أكثر من 130 دورة هدم وإعادة بناء اعتبارًا من يونيو 2018) وذلك إثر عودة أفراد قبيلة الطوري (بما في ذلك عائلة أبو ميدغم، أبو فريح، أبو زايد وأبو جابر) في عام 2002 لتأسيس قريتهم بالقرب من المقبرة. إلا أنّ التهجير الأول للسكان بدأ بتشرين الثاني عام 1951، أي بعد مرور ثلاثة أعوام على حرب 1948، عندما وجّه الجيش الإسرائيلي اهتمامه إلى البدو وباشر بتهجيرهم، كما فعل مع غيرهم من الفلسطينيين. منذ ذلك الحين، مارس السكان الأصليين للعراقيب، على مدار فترات غير منتظمة امتدت لأشهر وأحيانًا لعقود، حقهم في العودة الفعلية إلى أراضيهم، وأعادوا بناء قريتهم وزراعة اراضيهم بعد كل عملية هدم. الآثار المتبقية على الارض تشهد على استيطان  بدوي واسع مبني على الزراعة  في النقب منذ مئات السنين- الآبار، المباني، الحُطام، والأهم من ذلك، المقبرة- اقر ان المجال للعودة قائم. ولأنّ كل عودة تنتهي بالتهجير، فإن النكبة البدوية لا تزال مستمرة والسكان مستمرين بالمطالبة بحقهم الأصلي على أرضهم .
              `
        },
        {
          text: `
            وكان من بين العائدين الى اراضيهم من ابناء قبيلة العقبي الذين حاولوا العودة إليها تكرارًا بعد عام 1954 ولكن دون جدوى. في سنة 1973 حاول نوري العقبي، وهو ناشط بارز في مجال حقوق الإنسان ، العودة مرة أخرى ، والتي عقب اقتلاعه من أرضه  أسّس جمعية مؤازرة لحماية حقوق البدو، وهي منظّمة غير حكومية صغيرة (مكونة غالبًا من شخص واحد)، الأولى من نوعها، والداعمة للنضال البدوي من أجل الأرض. في تشرين اول من سنة 2006 نصب نوري العقبي خيمة احتجاجية على بعد كيلومتر واحد غربًا، بالقرب من حطام منزل والده الشيخ سليمان محمد العقبي. الخيمة الاحتجاجية دمرت وبنيت على مدار 3 سنوات حتى سنة 2009 عندما حظرت المحكمة الاسرائيلية وجوده في المنطقة. حتى ذلك الحين، كانت المنطقة قد تغيرت بشكل جذري. لم تعد العراقيب جزءًا من الحدود المفتوحة لحافة الصحراء، بل أصبحت بمثابة "جزيرة" صغيرة حصراء، محاطة بمستوطنات يهودية زراعية، غابات، قواعد عسكرية، طريق سريع، سكة حديد ومنشأة للتخلص من النفايات.
              `
        },
        {
          text: `
لا يزال الصراع على حقوق ملكية أراضي العائلات في العراقيب ونزوحهم مستمر. فهو يتطلب وسائل نضالية  متنوعة من - تحقيق العودة فعليا، إنشاء ونقل المباني ووضع استراتيجيات قانونية جديدة. الكم الكبير من الادلة التي تم جمعها على مر السنين يجب استخدامها وتفعيلها في محافل أخرى، منها الدولية، لمواصلة النضال من أجل حقوق البدو على أرضهم. هذا المشروع  هو جزء من هذا الجهد الذي يعتمد على فكر الحقيقة التي ستظهر حتميا.
              `
        },
        { type: "h2", text: "لجنة الحقيقة الأرضية" },
        { type: "img", src: "/assets/cabinet/history/groundtruth02.jpg" },
        {
          text: `في كانون الثاني- يناير 2016، بادرت اللجنة الشعبية في العراقيب، الوكالة البحثية Forensic Architecture وجمعية ذاكرات في تأسيس وبلورة منتدى مدني بديل بعنوان "الحقيقة الأرضية"، بقيادة ديبي فربر (مركزة معمل الفنون المرئية)، عزيز الطوري ونوري العقبي. وقد كانت بمثابة مؤسسة مُرتَجلة في مبنى مؤقت أقيم خارج المقبرة في العراقيب . تضمن النشاط جمع شهادات، وثائق وصور جوية مستقلة، وجلسة ختامية للجنة الحقيقة حول نكبة النقب، وهو مشروع طويل الأجل تديره جمعية ذاكرات: "الحقيقة الأرضية: الشهادات والحِرمان، الهدم والعودة في النقب".`
        },
        {
          text: `
              إن لجنة الحقيقة هي مبادرة مدنية تهدف إلى رفع مستوى الوعي وفضح مسؤولية دولة إسرائيل لارتكابها النكبة البدوية، مما أدى الى عواقبها المفجعة حتى اليوم. الغرض من الحدث الختامي هو تلخيص نشاط اللجنة على مدى السنوات الثلاث الماضية ونشر التقرير النهائي مع توصيات محتملة لتعديل مظالم الماضي والحاضر. مصطلح "لجنة الحقيقة" قد يكون مضللا. لجان الحقيقة التي أقيمت في أمريكا الجنوبية أو في جنوب أفريقيا كانت بمثابة أدوات لـ "العدالة الانتقالية"، وقد تأسست لمساعدة المجتمعات على تخطي المعاناة التي لحقت بهم بسبب إرهاب الدولة بعد انتهاء الصراع. ولكن لجنة الحقيقة غير الرسمية التي تقام في حالات الصراع والاحتلال المستمر، هي خطوة مجتمعية سياسية وتكتيكية تم تصميمها لإظهار وإنتاج المعرفة والأدلة من أجل لجان حقيقة رسمية مستقبلية للنضال المجتمعي المستمر.
              `
        },
        {
          text: `
              مشروع الحقيقة الأرضية كان بمثابة منتدى عام لجمع وعرض شهادات وأدلة الخبراء التي أنكِرت في المحكمة لأسباب وذرائع متعددة. لذلك، تطرق المشروع أيضًا إلى الظروف التي تسمح بجمع وعرض الأدلة القانونية والتاريخية. ولتحقيق هذه الغاية، قمنا بإجراء سلسلة من الفعاليات التي تخللت إنتاج، توثيق وتقديم الشهادات. تم تقديم الشهادات في معرض أرشيفي يسعى إلى تقفي اثر استمرار التدمير في المنطقة ونسب تجريد واقتلاع البدو من ديارهم ومن أراضيهم. تضمن المعرض وثائق ملكية الأراضي، مستندات شراء بدوية، إيصالات دفع الضرائب، مراسلات مع مسؤولين عثمانيين وبريطانيين وإسرائيليين، خرائط وصور جوية تاريخية للمنطقة قبل عام 1948. بالمقابل تم إنتاج صور جوية بشكل مستقل بالتعاون مع السكان المحليين كأدلة مستقبلية لإثبات وجود السكان المستمر على الأرض ومن أجل توسيع البحث المستمر في Forensic Architecture بما يتعلق بأنماط الاستيطان المبكر في الصور الجوية التاريخية. بالإضافة إلى ذلك ، فإن إطلاق كتاب إيال فايتسمان الجديد "حافة الصحراء ، خط المواجهة: الاستيطان والإخلاء في النقب"، مكننا من دراسة البيئة والمناخ من خلال القضايا التاريخية والقانونية المتعلقة في الأيديولوجية الصهيونية لتدنيس البرية والتي بالمقابل حددت مصير البدو الذين عاشوا على حافة الصحراء لمئات السنين.
              `
        },
        {
          text: `
              موعد إطلاق مشروع الحقيقة الأرضية تحدد لـ 1-2 كانون الثاني (يناير) 2016، لأننا أملنا بأنّ يمنحنا العام الجديد فرصة لاستجماع قوانا، والبقاء لأطول وقت ممكن في مبنى المنتدى الذي كان سيُهدَم حتمًا. في الثالث من كانون الثاني، أزيل المبنى من قبل مستخدميه، قبل قدوم الجرافات لهدمه. المواد الخام التي تم إنقاذها استخدمت لبناء عدة مبان أخرى على حواف الصحراء.
              `
        },
        {
          type: "video",
          src:
            "https://player.vimeo.com/video/223287790?title=0&byline=0&portrait=0"
        },
        {
          type: "img",
          src: "/assets/cabinet/history/pic058.jpg",
          caption:
            "Land documents presented at the Ground Truth Commission, 2016."
        },
        { type: "img", src: "/assets/cabinet/history/pic056.jpg" },
        {
          text:
            '<a target="_blank" href="https://www.youtube.com/watch?v=-ukCuvF7__E">Ground truth (Panel 1 - Part 1)</a>'
        },
        {
          text:
            '<a target="_blank" href="https://www.youtube.com/watch?v=S_9R8CbjfRw">Ground truth (Panel 1 - part 2)</a>'
        },
        {
          text:
            '<a target="_blank" href="https://www.youtube.com/watch?v=ZY5hmPxsyQI">Launch of the report of the Truth Commission for the events of 1948-1960 in the south</a>'
        },
        {
          text:
            "Ground Truth was scheduled for January 1 and 2, 2016, because we hoped the new year would give us a little breathing space, a stay on the forum’s inevitable demolition. On January 3, the structure was dismantled by its users, shortly before the bulldozers arrived to demolish it. The salvaged raw material has been used for the construction of several other structures in the area of the desert threshold."
        }
      ],
      resources: [
        { type: "h2", text: "وثائق" },
        {
          text: `
               لجنة الحقيقة الأرضية التي التقت في 1-2 كانون الثاني-يناير 2016 عملت على جمع الوثائق التي تدل على نظام حيازة الأراضي البدوي التقليدي في النقب، ويشمل ذلك وثائق نقل ملكية الأراضي، اتفاقيات حول نطاق المناطق القبلية، المبرمة بين زعماء القبائل المختلفة، إيصالات الضرائب  على الأراضي المحروثة (للزراعة) المدفوعة للسلطات البريطانية والإسرائيلية، خرائط، استمارات تسجيل الناخبين، بطاقات هوية شخصية تحمل تفاصيل مكان الولادة والإقامة. هذه الوثائق لا تدل فقط على استمرار الحياة البدوية في هذه المناطق، بل تشير أيضًا إلى احتمال قيام السكان سابقًا بزرع الحبوب على حواف الصحراء.
               `
        },
        {
          text: `
              هذه المجموعة هي المرحلة الأولى من الأرشيف الإلكتروني الذي سيقام قريبًا، والذي سيتضمن أدلة موثقة على استخدام الأراضي.
              `
        }
      ]
    }
  },

  he: {
    loading: "...טוען",
    title: "כותרת",
    description: "תיאור",
    tags: "תגים",
    date: "זְמַן",
    ui: {
      title: "אמת קרקעית",
      "Al Turi": "אל-טורי",
      Uqbi: "אל-עוקבי",
      "Abu Freih": "אבו-פריח",
      "Abu Siam": "אבו סיאם",
      Family: "משפחה",
      "Marker Group": "אתרים",
      Plot: "חלקה",
      Burial: "קבר",
      Cistern: "בור מים",
      Cultivated: "חלקה מעובדת",
      Fortifications: "ביצורים",
      Granary: "ממגורה",
      House: "בית",
      "Land Feature": "מאפייני קרקע",
      Tent: "אוהל",
      "Un-cultivated": "חלקה לא מעובדת",
      Well: "באר",
      Image: "תצלומים",
      Audio: "סאונד",
      Video: "וידיאו",
      Cemetery: "בית קברות"
    },
    cabinet: {
      terms: {
        overtitle: "الـحقيقة الأرضيّة",
        title: "אמת קרקעית",
        untertitle: "הרס ושיבה באל-עראקיב",
        untertitle_ar: "سِجلّات التهجير والعودة",
        explore: "מיפוי",
        about: "אודות הפרויקט",
        methodology: "מתודולוגיה",
        history: "רקע הסטורי",
        resources: "מסמכים",
        collaborators: "שותפים לפרוייקט",
        investigate: "לחקור",
        land: "מסמכים",
        map: "מפות ותמונות אוויר"
      },
      about: [
        { type: "h2", text: "אודות הפרוייקט" },
        {
          type: "video",
          src:
            "https://player.vimeo.com/video/223268224?title=0&byline=0&portrait=0"
        },
        {
          text: `
            ״אמת קרקעית״ הינו פרויקט מחקרי מתמשך של איסוף וייצור עדויות היסטוריות ומשפטיות עבור הקהילות בכפרים הבדואים- הפלסטינים שהוצאו על ידי השלטון הישראלי אל מחוץ לחוק (אלו המכונים כיום כפרים "בלתי-מוכרים") בשוליו הצפוניים של הנגב/אל-נַקַבּ.
            `
        },
        {
          text: `
            עקירתם בכוח והגדרתם של כפרים אלו כבלתי חוקיים מאפשרים את מחיקתם של  כפרים אלו מהמפות ומתצלומי האוויר הרשמיים בעוד עבודות הכשרת הקרקע והייעור שמובילה המדינה באמצעות קק״ל, משנות את פני הקרקע ומוחקות באופן שיטתי את השרידים ההיסטוריים המעידים על דפוסי שימוש של עיבוד ויישוב האדמות בנגב מזה מאות בשנים.
            `
        },
        {
          text: `
            מטרת הפרויקט אפוא הינה לתעד, לייצר ולאגד עדויות משפטיות, הסטוריות וחומריות של רציפות נוכחותם הילידית של הבדואים הפלסטינים כיושבי קבע על אדמה זו, כמו גם לאתר את עקבותיהם של מחזורי הגירוש וההרס המבוצעים על ידי השלטון הישראלי.
            `
        },
        {
          text: `
            בבסיס הפרויקט תצלומים שתיעדו תושבי הכפרים, ופלטפורמת מיפוי גיאוגרפי תלת מימדית, אשר מתבססת על ניתוח והצלבה של תצלומי אוויר וסטילס, היסטוריים ועכשוויים, המאפשרים למפות, אופקית ואנכית, מהאויר ומהקרקע, את נוכחותם ושרידיהם של היישובים הבדואים-פלסטינים. השלב הראשון בפרויקט מתמקד בכפר אל-עראקיב, כפר שנהרס ונבנה מחדש מעל למאה ושלושים פעמים בשבעים השנים האחרונות והפך לסמל למאבקם של הכפרים ה״בלתי-מוכרים״ בנגב. בשלב השני של הפרויקט תורחב העבודה אל כפרים נוספים, שבהם שילוב המתודולוגיה שפיתחנו יוכלו לתרום ברישום העדויות לנוכחות הקבע ולסייע לתושבים במאבקם על ההכרה בזכויות הבעלות שלהם.
            `
        },
        {
          text: `
            במסגרת שיתוף הפעולה המתמשך בין Public Lab, Forensic Architecture, עמותת זוכרות, והמשפחות המקומיות באל-עראקיב, נוצר מעין "לוויין אזרחי" דרכו מיוצרים ומופקים תצלומי אוויר עצמאיים בפרקטיקת DIY (עשי זאת בעצמך). לווין זה מורכב מעפיפונים או בלוני הליום עליהם מותקנות מצלמות דיגיטליות פשוטות. התמונות ״נתפרות״ יחד כדי ליצור תצלום אוויר של הכפר אליו מתווספים נתונים מרחביים נוספים. עיבוד פוטוגרמטרי (ראו להלן בעמוד "מתודולוגיה") מאפשר המרה של המידע המקודד בתצלומי האוויר והקרקע ל"ענן נקודות" – פני שטח צילומיים תלת-מימדיים המקושרים למפה אינטרנטית המלכדים את פני השטח של הכפר עם מה שמצוי מתחתם. העיבוד התלת-ממדי הממוחשב של שכבות המידע שיוצרו מהקרקע והאויר מאפשר להציג בו זמנית עדויות מן העבר וההווה של פני השטח של הכפר.  הפלטפורמה מאגדת גם מסמכי בעלות היסטוריים, חוזים והסכמים, עדויות שבעל פה וסרטונים שנאספו מתושבי הכפר ומהפעילים- אלו מתעדים לא רק את מחזורי הגירוש וההרס, אלא גם את חייהם המתמשכים וההתנגדות ואת הצומוד, האחזותם העיקשת והאמיצה בקרקע.
            `
        },
        {
          text: `
            הפרויקט מבקש גם לקשור בין תולדות המאבק המקומי הזה על האדמה לבין תמורות סביבתיות בקנה מידה מרחבי ועתי רחב יותר ולסכסוכים שעוררו תמורות אלו (להרחבה על הקשר בין שינוי אקלים לקולוניזציה ראו ספרו של איל ויצמן: "סף המדבר, קו העימות: יישוב ופינוי כשינוי אקלים בנגב" בהוצאת עמותת זוכרות ובבל, 2015).
            `
        },
        {
          text: `
            המידע אודות האתרים ההיסטוריים השונים המופיע בפלטפורמה נאסף במהלך שלושת השנים האחרונות על ידי ראיונות של תושבי ותושבות כפר אל-עראקיב, מסקרים ארכיאולוגיים וממחקרים היסטורים וגיאוגרפים מגוונים (ר' עמוד היסטוריה).
            `
        },
        {
          text: `
            הפרויקט הינו ארכיון חי ופעיל של הכפר אל-עראקיב - אנחנו מזמינות את כל מי שבידיו/ה חומרים העשויים להיות רלוונטים לפרויקט, לפנות אלינו לכתובת המייל:naqabplatform@gmail.com
            `
        },
        { type: "h2", text: "הארגונים השותפים לפרויקט:" },
        {
          text: `
            "אמת קרקעית" הינו תוצר של שיתוף פעולה מתמשך בין הקהילה הבדואית הפלסטינית של אל-עראקיב ומכון המחקר Forensics Architecture, עמותת זוכרות ו-Public Lab שראשיתו ב-2016 בפורום הפומבי "אמת קרקעית: עדויות של נישול, שיבה והרס סביבתי בנגב/אלנקב", שכלל את סדרת אירועי המושב האחרון של ועדת האמת לאירועי 1948-1960 בנגב, פרויקט מיוזמתה של עמותת זוכרות.
            `
        },
        {
          text: `
            נציגי קהילת אל-עראקיב: נורי אל-עקבי, שייח' סיאח אבו מדיע׳ם אל-טורי, עזיז אל-טורי, סלים אבו מדיע'ם, אחמד אבו מדיע'ם, עוואד אבו פריח, סבאח אל-טורי, חאכמה אל-טורי, מריאם אבו מדיע'ם.
            `
        },
        {
          text: `
            Forensic Architecture: מכון המחקר לארכיטקטורה פורנזית באוניברסיטת גולדסמית׳ס, לונדון. במכון שותפים אדריכלים, חוקרים, קולנוענים, מעצבים, משפטנים ומדענים אשר עורכים מחקרים שאוספים ומציגים עדויות וניתוחים מרחביים עבור צוותי תובעים בינלאומיים, ארגונים פוליטיים, עמותות והאו"ם. בנוסף לכך, המכון מקדם ומייצר מחקרים על פרקטיקות פורנזיות היסטוריות ועכשוויות ומושגים הקשורים לאמת פומבית. חברי הצוות: איל ויצמן (מייסד המכון וחוקר ראשי), אריאל קן (מוביל הפרוייקט, צילום, עיבוד ומחקר), פרנק קמפּס-פבּרר (עיצוב ופיתוח תוכנה), סאמאנה מואפי (עריכת סרטים) וכריסטינה וארוויה.
            `
        },
        {
          text: `עמותת זוכרות פועלת מאז 2002 בישראל לקידום ההכרה בנכבה הפלסטינית ולקידום זכות השיבה של הפליטים הפלסטינים כתיקון המתחייב והצודק לעוולות הנכבה המתמשכת.. פעילויות העמותה העיקריות כוללות סיורים לאתרי יישובים פלסטיניים הרוסים, סמינרים לנשות ואנשי חינוך, איסוף עדויות בע"פ, גלריה לאמנות, פסטיבל סרטים וארכיון מקוון על הנכבה והשיבה. רכזי הפרויקט בזוכרות: דבי פרבר (אוצרת הגלריה) עמר אלע'בארי (מנהל תחום מרחב לשיבה), עוזרות מחקר: רנא גנאים, לוטה ברג-תומסן.`
        },
        { text: "שותפים נוספים לפרויקט:" },
        {
          text: `
            Public Lab המעבדה הציבורית לטכנולוגיה ומדע היא קהילה פתוחה של אנשי טכנולוגיה, חוקרות, אקטיביסטיות, אמניות ומומחיות אחרות העוסקות בפיתוח של כלים ושיטות למחקר סביבתי, חברתי ופוליטי המאפשרים יצירה, ניתוח והפצה של תצלומי אוויר באופן עצמאי. המיפוי מבוסס על חומרה פתוחה (Open Hardware) ועל שיטות ״עשי זאת בעצמך״ (DIY) המורכב מחומרים יומיומיים כמו עפיפון, בלון, גומיות או בקבוק פלסטיק. מטרתה העיקרית היא לייצר ידע גיאוגרפי מקומי אוטונומי ולהעניק את השליטה לקהילה על אופן ייצור הצילום האווירי, קריאתו והשימוש בו. שותפה לפרויקט: חגית קיסר.
            `
        },
        {
          text: `
            קולקטיב אקטיבסטילס הוקם ב-2005 על ידי קבוצה של צלמים מתוך אמונה עמוקה כי הצילום מהווה כלי לשינוי חברתי ופוליטי. הם מאמינים בכוחם של דימויים לעצב את דעת הקהל ולהעלות מודעות לסוגיות שלרוב נעדרות מהשיח הציבורי. חברי הקולקטיב – צלמים ישראלים, פלסטינים ובינלאומיים – רואים עצמם חלק מהמאבק נגד כל צורות הדיכוי והגזענות ונגד הפרות של זכות האדם הבסיסית לחירות. הקולקטיב פועל בפלסטין/ישראל ומתמקד בתיעוד חברתי ופוליטי, פרסומים ותערוכות. הקולקטיב עוסק בשורה של נושאים, כולל המאבק העממי הפלסטיני נגד הכיבוש, זכויות נשים, להטב"ק, מהגרים ומבקשי מקלט, דיור ציבורי וצורות אחרות של דיכוי כלכלי. חברי אקטיבסטילס השותפים לפרויקט: אורן זיו, קרן מנור ויותם רונן.
            `
        },
        {
          text: `
            פרופסור אורן יפתחאל מלמד גיאוגרפיה מדינית ומשפטית, תכנון עירוני ואזורי ומדיניות ציבורית באוניברסיטת בן-גוריון בנגב יפתחאל הוא פעיל חברתי ופוליטי הפועל מזה שנים רבות לקידום קשת רחבה של זכויות אדם בשטחים הכבושים, במאבקים למען צדק חלוקתי וזכויות חברתיות וכלכליות, ובמאבק למען זכותם של הבדואים להכרה בכפריהם ובזכויותיהם על אדמותיהם ההיסטוריות. בין היתר היה עורך שותף לתכנית אב עבור היישובים הבדואים המהווה חלופה ברת קיימא לתכנית פראוור הממשלתית, שימש כיועץ למועצה לכפרים הלא-מוכרים והוביל את הצוות המקצועי שנרתם לבחון את תולדות הסכסוך הקרקעי בין חלקים משבט אל-עקבי ולבין המדינה, והכין והציג חוות דעת מומחה בתיקים אלו.
            `
        },
        {
          text: `
            מיקי קרצמן הוא אמן וצלם. "הארכיון החזותי הבדואי", פרויקט שהוא מקדם בשיתוף הפורום לדו-קיום בנגב, שואף להשתמש בצילום כדי להעלות את המודעות להפרות זכויות האדם של הבדואים ולתת קול לעברם המושתק ולתביעותיהם לאדמתם. מיכאל ספרד הוא עורך דין המתמחה במשפט זכויות האדם הבינלאומי ובדיני מלחמה. הוא טיפל בשורה של תיקים משפטיים בנושאים אלה בישראל. ספרד ייצג בבג"ץ מגוון ארגוני זכויות אדם ושלום, תנועות ופעילים, פלסטינים וישראלים. בפרויקט משתתפים ספרד ולצדו עו״ד כרמל פומרנץ.
            `
        },
        {
          text: `
            משתתפים נוספים בפרויקט סטודנטים מהקורסים הבאים:
            `
        },
        {
          text: `
            קורס לתואר שני באדריכלות פורנזית (MAFA) במרכז לאדריכלות מחקרית, אוניברסיטת גולדסמיתס בלונדון, 2017, בהנחיית איל ויצמן ולורנצו פצאני.
            `
        },
        {
          text: `
            "סף המדבר, קו העימות II", אוניברסיטת פרינסטון, בהוראת אדוארדו קדאבה ואיל ויצמן באביב 2017.
            `
        }
      ],
      methodology: [
        {
          text: `
            כיוון שהאלימות הנכפית על המרחב, הריסת מבנים, סתימת בארות, סכירת נחלים ועוד, מתרחשת בשלושה מימדים, הרישום והמיפוי של ההרס המתמשך מחייב גם הוא לתעד את המרחב והנפח החומרי. בבסיס העבודה שלנו נמצאת ההבנה של הצילום לא רק ככלי המייצר דימוי או מידע אלא כמרחב אדריכלי.
            `
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/kite.jpg",
          caption:
            "עפיפון ומצלמה מעל בור המים של מוחמד אבן סלאמה אל-עקבי, נובמבר 2016 "
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pic013.jpg",
          caption:
            "עפיפון ומצלמה מעל בית הקברות של משפחת אל-טורי, ינואר 2016. אריאל קן, חגית קיסר עם ילדי אל-עראקיב"
        },
        {
          text: `
            כדי לרשום את המרחב של אל-עראקיב באופן המאפשר לנוע ממבט על אוירי דרך פני השטח ועד לחלל פנים של באר או מערה אנחנו משלבים יחד נקודות מבט מעשרות אלפי תצלומים מהקרקע ומהאוויר, זאת במבוסס על פרקטיקת צילום אויר קהילתי שפותחה על ידי  המעבדה הציבורית (Public Lab) המאפשרת ליצור תצלומי אוויר ומיפוי באופן עצמאי (DIY) באמצעות טכנולוגיות קוד פתוח נגישות ופשוטות, על מנת להתמודד עם סוגיות מרחביות-סביבתיות שאינן מקבלות מענה על ידי הרשויות.
            `
        },
        {
          text: `
            אנו משתמשים במצלמות דיגיטליות קטנות וקלות (Canon, GoPro Hero5 Black, Olympus TG-4) (למצלמה אפשרות לצילום מתמשך) אותן אנו מחברים לעפיפונים פשוטים ובלוני הליום שנושאים את המצלמה לשמיים. עדשת המצלמה מכוונות בזווית רחבה יחסית (המקבילה לעדשת 25-35 מ"מ של מצלמת פילם בפריים מלא) כלפי הקרקע והמצלמה מופעלת על ׳צילום רצף׳. מרגע שנשלם סבב צילום, יש ברשותנו מקבץ של כמה מאות או אלפי דימויים המתעדים מטס שלם. הדימויים מקבלים שמות ומספור רציף במצלמה, ותיעודם הדיגיטלי כולל זמן ותאריך. בדגמי המצלמות בהם אנו משתמשים כיום, בכל פריים משובצים גם נתוני GPS בסיסיים.
            `
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pointcloud.jpg",
          caption:
            "ענן נקודות של באר של עוימר סלמאן אבו מדיע׳ם, ספטמבר 2016. המלבנים הכחולים מסמנים את מיקומם של הדימויים מהם חושב המידע התלת מימדי"
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/photogrammetry.png",
          caption: "ענן נקודות, עיבוד ומיקום מרחבי. אריאל קן"
        },
        {
          type: "img",
          src: "/assets/cabinet/methodology/pic003.jpg",
          caption:
            "מצלמה ותושבת מבקבוק פלסטיק. חגית קיסר, אריאל קן & Forensic Architecture"
        },
        {
          text: `
            אל צילומי האוויר אנחנו מצרפים תיעוד של השרידים להתיישבות הקבע של משפחות הכפר אל-עראקיב גם מהקרקע, בטרם הריסתם על ידי קק״ל או כוחות המשטרה.
            `
        },
        {
          text: `
            כדי ליצור תצלומים תלת מימדיים מעוכנים גיאוגרפית ומדוייקים ככל הניתן השתמשנו בתהליך חישובי המכונה פוטוגרמטריה. בתהליך זה, מדידות המרחק והתנועה נגזרות מתוך השוואה בין מספר תמונות סטילס. באמצעות חישוב טריאנגולציה המביא בחשבון את נתוני העדשה הנשלפים מהתיעוד הדיגיטלי של כל תמונה, כל צילום מוצב במרחב תלת-ממדי וכל פיקסל בדימויים המקוריים מקבל אף הוא את מקומו המתאים בסביבה התלת-ממדית. כל מקטע בענן הנקודות שנוצר בדרך זו מוצלב כנגד נקודות בקרה קרקעיות ומקבל נתוני אורך, רוחב וגובה. ההצלבה לנתונים הקרקעיים מושגת באמצעות שילוב של הנתונים הדיגיטליים שעל המצלמה ונתוני סקר קרקעי עדכניים ממפה שסופקה לנו על ידי פרופ' אורן יפתחאל (אוניברסיטת בן גוריון בנגב). כך נוצרים מודלים מדידים וממוצבים של האתרים.
            `
        }
      ],
      history: [
        { type: "h2", text: "רקע הסטורי" },
        {
          text: `
            האוכלוסיה הבדואית הפלסטינית בנגב/אל-נַקַבּ היא הקבוצה המודרת והענייה ביותר מבין אזרחיה הפלסטינים של מדינת ישראל. עד מלחמת 1948 והקמתה של מדינת ישראל, חיו בחלקה הדרומי  בין 65,000-100,000 בדואים פלסטינים ששלטו בשטח של כ-5 מליון דונמים. הן השלטונות העות'מאניים והן שלטונות המנדט הבריטי בפלסטין, הכירו במערכת הבעלות השבטית הבדואית על אדמותיהם. בדומה לגורלם של כ-800,000 פלסטינים שגורשו מיישוביהם ואדמותיהם בזמן הנכבה ושיבתם נאסרה, גורשו גם מרביתם של תושבי הנגב/אל-נַקַבּ לעזה, לגדה המערבית והמזרחית ולירדן. גירושים אלה לוו גם במעשי הרג אכזריים, שריפת אוהלים, הרס בתי אבן ואטימת בארות. כ-11,000 התושבים שהצליחו להישאר לאחר הנכבה,רוכזו על ידי הממשל הצבאי הישראלי בסִיָג' - אזור מוגבל בחלקיו הצחיחים יותר של המדבר, בעוד הבעלות על אדמותיהם נשללה. זאת הודות למערכת חוקים שיצרה מדינת ישראל מאז 1948, המאפשרת להפקיע את הקרקעות בנגב בקלות, תוך אימוצו של הגיון משפטי קולוניאלי, שהוגדר על ידי הגיאוגרף אורן יפתחאל כ״הלכת הנגב המת״. דוקטרינה דרקונית זו קובעת כי האדמות עליהן תובעים הבדואים בעלות הן מסוג ״מוואת״: קרקעות ״מתות״ ושוממות וכי עד לתקופת המנד״ט הבריטי לא היו בנגב התיישבות וחקלאות בדואיות משמעותיות. הלכה זו לא רק שמבנה את הבדואים כנוודים חסרי שורשים, אלא גם מרוקנת בפועל את זכויות הקניין המסורתיות ומאפשרת למדינה לנכס ולהפקיע את הקרקעות. כל זאת תוך התעלמות שיטתית ומתמשכת מנתונים, ראיות, חוות דעת וטיעונים משפטיים, גיאוגרפים והיסטוריים המצביעים על העבר הילידי של הנגב.
            `
        },
        {
          text: `
            כיום מתגוררים בנגב/אל-נקב כ-230,000 בדואים, מחציתם בשבע עיירות ריכוז עניות שהקימה ישראל וב-50 כפרים, שמתוכם רק כעשרה זכו להכרת המדינה. המתגוררים באותם כפרים 'בלתי מוכרים' חיים מחוץ למפה, מחוץ לרדאר, בלי שירותים ותשתיות ותחת איום מתמיד בנישול ועקירה. במהלך שבעים השנה האחרונות, הפקיעה ישראל את האדמות ממנה פינתה את הבדואים בתואנות שונות לטובת הקמתם של ישובים על טהרת היהודים ונטיעת יערות, כמו גם תעשיות מזהמות, מזבלות, בתי כלא, בסיסי צבא ושטחי אש.
            `
        },
        {
          type: "img",
          src: "/assets/cabinet/history/Aziz_2008map_01.jpg",
          caption:
            "עזיז אל-טורי קורא תצלום אויר משנת 2009 בה נראים בית הקברות של המשפחה והכפר לפני שהוחרב בשנת 2010 "
        },
        { type: "h2", text: `אל-עראקיב` },
        {
          text: `
            משמעות המילה ״אל-עראקיב״ בערבית היא הגבעות הנמתחות בין הנחלים. יש למילה משמעויות נוספות, אך המשמעות הזו נראית המתאימה ביותר לאיזור, המשופע בנחלים ובגבעות עדינות. השטח רחב ידיים, וגודלו כ-100 אלף דונם, השייכים למספר שבטים ומשפחות פלסטיניות שגרו על אדמתם ועבדו אותה במשך מאות בשנים.
            `
        },
        {
          text: `
            הכפר אל-עראקיב הפך לסמל המאבק של הכפרים המוגדרים כ״לא מוכרים״ בנגב, על רקע מחזורי ההרס החוזרים ונשנים המהווים את הפרק החדש במה שהממסד וכלי התקשורת בישראל נוהגים לכנות "הקרב על הנגב". מדובר במהלך שיטתי של המדינה לעקור את הבדואים, לרכזם בעיירות שהוקמו ברובן, ובמכוון, בחלקיו הצחיחים יותר של המדבר, ולהקצות את אדמותיהם ליישובים יהודיים.
            `
        },
        {
          text: `
            בשיאה, מנתה אוכלוסיית אל-עראקיב כ-400 נפש. כיום נותר רק גרעין קטן של כתריסר תושבים, המתגוררים בסמוך לבית הקברות של משפחת אל-טורי. מניין ההריסות הנוכחי (ניתן למנות מעל ל-130 מחזורי הריסות ובנייה מחדש נכון ליולי 2018) החל בשנת 2010 לאחר שבני שבט אל-טורי (הכוללים את משפחת אבו מדיע׳ם, אבו פריח, אבו זאיד ואבו ג׳אבר) שבו ב-2002 להקים את כפרם בסמוך לבית הקברות. אך הגירושים הראשונים החלו כבר בנובמבר 1951, כשהצבא החל לגרש את הבדואים, בתואנות שונות. מאז, במרווחים לא סדירים שלעתים נמשכו חודשים ולעתים עשורים, מימשו תושביו המקוריים של אל-עראקיב וצאצאיהם את זכות השיבה שלהם, פשוטה כמשמעה, והתעקשו לבנות ולשוב ולבנות את בתיהם ולעבד את אדמותיהם לאחר כל גל הריסות. העקבות שהותירו על הקרקע המעידות על התיישבות בדואית נרחבת ועיסוק ניכר בחקלאות של מאות שנים בנגב – בארות, מבנים, הריסות ובעיקר בית הקברות – מותירים את אפשרות השיבה שרירה וקיימת. למרות שכל שיבה מובילה לגירוש כחלק מהנכבה הבדואית המתמשכת, ממשיכים התושבים באומץ לתבוע ולממש את הזכות הילידית שלהם על אדמתם.
            `
        },
        {
          text: `
            בין השבים היו גם בני שבט אל-עֻקְבִּי, אשר החל משנת 1954, ניסו לשוב פעם לאחר פעם אך ללא הצלחה. ב-1973, יזם נורי אל-עֻקְבִּי, פעיל זכויות אדם בולט, נסיון שיבה נוסף, שלאחר עקירתו הוביל ,  לייסודה של  האגודה להגנת זכויות הבדואים, עמותה קטנה וראשונה מסוגה המחויבת למאבק הבדואים על אדמתם. באוקטובר 2006, הקים אל-עקבי אוהל מחאה כקילומטר מערבית משם, בסמוך להריסות בית אביו השיח׳ סלימאן מוחמד אל-עקבי. האוהל נהרס ונבנה מחדש במהלך שלוש שנים, עד שב-2009 אף נאסרה נוכחותו באתר על ידי בתי המשפט הישראלים. עד אז, האזור עבר תמורה קיצונית. אל-עראקיב לא היה עוד חלק מהספר הפתוח של שולי המדבר, אלא נהפך למעין אי בלב היבשה, מוקף מכל צדיו ביישובים חקלאיים יהודיים, בסיסי צבא, כביש מהיר, מסילת ברזל ומזבלה.
            `
        },
        {
          text: `
            מחיקת רישומו של הכפר מן המפות, תצלומי הלויין ומן הרשומות ההיסטוריות, מלווה בשנים האחרונות במחיקה ובשינוי פני הקרקע על ידי נטיעתם של יערות קק״ל על כל שטחי התביעה הבדואית לבעלות (יער שגרירים, יער משמר הנגב ויעד דודאים). עבודות הקרקע האלו משנות את תוואי תכסית השטח, מלוות בסתימת בארות והריסת מבני אבן היסטוריים, טשטוש גבולות בתי קברות ובבסיסם מניעת כל אפשרות לשיבה עתידית אל הקרקע ביום בו מאבקם של המשפחות יצלח.
            `
        },
        {
          text: `
            המאבק העיקש והאמיץ על זכויות המשפחות על אדמתם באל-עראקיב ונגד הנישול המתמשך עודנו ארוך, ונדרש לדרכי מאבק מגוונות — מימוש שיבה בפועל, הקמה וניוד של מבנים, וכן פיתוח אסטרטגיות משפטיות חדשות. הררי העדויות שנאספו לאורך השנים יצטרכו לשמש בפורומים אחרים, בינלאומיים, כדי להמשיך במאבק למען זכויות הבדואים על אדמתם.
פרויקט זה מהווה חלק ממאמץ זה, מתוך האמונה שהאמת סופה לצאת לאור.
            `
        },
        { type: "h2", text: `ועדת האמת` },
        { type: "img", src: "/assets/cabinet/history/groundtruth02.jpg" },
        {
          text: `
            בינואר 2016, הוועד העממי של אל-עראקיב, עמותת זוכרות ו- Forensic Architecture יזמו את הקמתו של פורום ציבורי אזרחי: ״אמת קרקעית: עדויות של נישול, הרס סביבתי ושיבה״, שאצרו דבי פרבר, עזיז אל-טורי ונורי אל-עקבי. היה זה מוסד מאולתר במבנה זמני שהוקם מחוץ לבית הקברות של אל-עראקיב. במהלך סדרת האירועים עסקנו באיסוף עדויות ומסמכים היסטוריים ובייצור תצלומי אויר באופן עצמאי, וכן קיימנו את המושב המסכם של ועדת האמת על הנכבה בנגב-אלנקב, פרויקט מתמשך של זוכרות (ר' להלן).
            `
        },
        {
          text: `
            ועדת האמת הינה יוזמה אזרחית שנועדה להעלות מודעות ולחשוף את אחריותה של מדינת לישראל לנכבה הבדואית ולהשלכותיה עד ההווה המדמם כיום. אירוע הסיום נועד לסכם את פעילותה של הועדה בשלוש השנים האחרונות ולהשיק את הדו״ח הסופי עם המלצות לתיקון אפשרי עבור עוולות העבר וההווה. המונח ועדת אמת עשוי להטעות. ועדות האמת שהוקמו בדרום אמריקה או בדרום אפריקה נועדו לקדם צדק מעברי, כלומר את ההתמודדות של חברות עם צלקות העבר של טרור מדינתי לאחר שהקונפליקט הגיע לתומו. לעומת זאת, ועדת אמת לא רשמית המתכנסת בעת שהסכסוך והכיבוש טרם באו אל קצם מהווה אקט אזרחי, פוליטי וטקטי שנועד לייצר יידע ועדויות עבור וועדות אמת רשמיות שעוד יקומו בתקווה בעתיד, כחלק מהמאבק האזרחי המתמשך עצמו.
            `
        },
        {
          text: `
            ״אמת קרקעית״ היה פורום ציבורי לאיסוף והצגה של עדויות מומחים, טענות וראיות שנפסלו בבית המשפט מסיבות ותואנות שונות. לפיכך, היה על הפורום להתמודד עם עצם התנאים שמאפשרים איסוף ראיות הסטוריות ומשפטיות, הצגתן, ראייתן ושמיעתן. לשם כך נדרשנו לסדרה של פעולות שכללו את הצגתן של העדויות אך גם את ייצורן ותיעודן בזמן אמת. העדויות הוצגו במסגרתה של תערוכה ארכיונית שביקשה לעקוב אחר נוכחותו המתמשכת של ההרס במרחב ואחר הגנאלוגיה של נישול הבדואים ועקירתם מאדמותיהם. התערוכה כללה תעודות בעלות על הקרקעות, שטרי רכישה בדואים (סנדים), קבלות על תשלומי מסים ותכתובות עם פקידים עות'מאניים, בריטים וישראלים, מפות ותצלומי אויר היסטורים של האיזור לפני 1948. במקביל, על מנת להרחיב את המחקר המתמשך של Forensic Architecture לאיתור דפוסי יישוב מוקדמים בתצלומי האויר ההיסטוריים, יוצרו תצלומי אויר באופן עצמאי בשיתוף עם התושבים כעדויות עתידיות להוכחת הנוכחות המתמשכת של התושבים על הקרקע. בנוסף, השקתו של ספרו החדש של איל ויצמן ״סף המדבר, קו העימות: יישוב ופינוי בנגב״, אפשרה לבחון את הסביבה ואת האקלים דרך סוגיות היסטוריות ומשפטיות הכרוכות באידיאולוגיה הציונית של הפרחת השממה, זו שחרצה את גורלם של הבדואים שחיים על סף המדבר מאות שנים.
            `
        },
        {
          type: "video",
          src:
            "https://player.vimeo.com/video/223287790?title=0&byline=0&portrait=0"
        },
        {
          type: "img",
          src: "/assets/cabinet/history/pic058.jpg",
          caption: "מסמכי בעלות מוצגים במהלך ועדת האמת, 2016"
        },
        { type: "img", src: "/assets/cabinet/history/pic056.jpg" },
        {
          text: `<a target="_blank" href="https://www.youtube.com/watch?v=-ukCuvF7__E">אמת קרקעית (מושב א' – חלק א)</a>`
        },
        {
          text: `<a target="_blank" href="https://www.youtube.com/watch?v=S_9R8CbjfRw">אמת קרקעית (מושב א' – חלק ב)</a>`
        },
        {
          text: `<a target="_blank" href="https://www.youtube.com/watch?v=ZY5hmPxsyQI">
השקת דו"ח ועדת האמת לאירועי 1948-1960 בדרום
</a>`
        },
        {
          text: `
            אירועי "אמת קרקעית" נקבעו ל-1 ול-2 בינואר 2016, כיוון שקיווינו שהשנה החדשה תיתן לנו קצת מרחב נשימה, ארכה לפני ההרס הבלתי נמנע של הפורום. ב-3 בינואר, פורק המבנה על ידי יושביו, זמן קצר בטרם הגיעו הדחפורים. חומרי הגלם של המבנה שימשו להקמת מספר מבנים אחרים עבור שיקום ההריסות העתידיות של בתיהם, באזור שעל סף המדבר.
            `
        },
        {
          text: `
            ויצמן, א. (2015), סף המדבר, קו העימות: יישוב ופינוי כשינוי אקלים בנגב, תל אביב: הוצאת זוכרות ובבל
            `
        },
        {
          text: `
            אלע׳בארי, ע. (2009) (עורך), ״זוכרות את אלעראקיב״, תל אביב: הוצאת זוכרות
            `
        }
      ],
      resources: [
        {
          text: `
            סדרת האירועים ״אמת קרקעית: עדויות על נישול, הרס והרס סביבתי בנגב״ שהתקיימה ב-1-2 בינואר 2016 היתה כרוכה באיסוף מסמכים המעידים על הבעלות המסורתית של הבדואים על אדמתם בנקב/נגב, שתועדו על ידי הצלם מיקי קרצמן ואורכבו על ידי Forensic Architecture וזוכרות. אלו כוללים מסמכי העברת בעלות, הסכמים על היקף האזורים השבטיים שנחתמו בין שייח'ים שונים, קבלות על מסי עיבוד קרקעות ששולמו לרשויות הבריטיות והישראליות, מפות, טפסי רישום הצבעה, ותעודות זהות עליהן רשומים מקום הלידה והמגורים. המסמכים הללו מעידים לא רק על ההתיישבות הרציפה באזורים אלה, אלא גם על ההיתכנות של גידולי דגנים על סף המדבר, על אף טענות המדינה כי לא ייתכנו עיבוד ויישובי קבע מעבר לסף זה.
            `
        },
        {
          text: `
            אוסף זה מהווה שלב ראשון בפיתוח ארכיון מקוון של עדויות על שימושי קרקע בנגב, שייפתח בקרוב.
            `
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./application/frontend/src/data/copy.js